import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { b64EncodeUnicode } from 'Utils/crypto/b64EncodeUnicode';


const saveDataToCookies = (data) => {
  const data64 = b64EncodeUnicode(JSON.stringify(data));
  Cookies.set('uspt', data64, { expires: 1 });
};

const loadDataFromCookies = () => {
  const savedData = Cookies.get('uspt');
  return savedData ? JSON.parse(atob(savedData)) : null;
};

const useParticipantSubSegment = () => {
  const savedData = loadDataFromCookies();
  const participantGroups = useSelector(
    (state) => state.SpotGroups.participantsGroups
  );
  const participantSubsegment =
    useSelector(
      (state) => state.SpotGroups.dataSubSegmento?.participantSubsegment
    ) || savedData?.participantSubsegment;

  const isFocalizationAnalystRedux = useSelector(
    (state) => state.SpotGroups.dataSubSegmento?.isFocalizationAnalyst
  );

  const isManager = useSelector(
    (state) => state.SpotGroups.hasSyngentaHierarchy
  );

  const getRedemptionSpotGroups = () => {
    if (process.env.REACT_APP_REDEMPTION_SPOT_GROUPS) {
      let group = participantSubsegment;
      let groups = process.env.REACT_APP_REDEMPTION_SPOT_GROUPS.split(',');
      return groups.includes(group);
    }
    return false;
  };

  const isPMO = participantSubsegment === 'PMO';
  const isLead = participantSubsegment === 'Gestor Acessa Agro';
  const isFocalizationAnalyst = isFocalizationAnalystRedux === true;

  saveDataToCookies({
    participantSubsegment,
    isFocalizationAnalyst,
    isPMO,
    isLead,
    isManager,
    participantGroups,
  });

  return {
    participantSubsegment,
    participantGroups,
    isFocalizationAnalyst,
    isPMO,
    isLead,
    isManager,
    getRedemptionSpotGroups,
  };
};

export default useParticipantSubSegment;
